export default "__VITE_ASSET__DvnwrKLA__"